import { useEffect, useMemo, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { Lock } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let stripePromise = null;

export const PaymentStep = ({ clientSecret, tc }) => {
  const [pk, setPk] = useState(null);
  useEffect(() => {
    axios.get(`${API}/payments/config`).then((r) => setPk(r.data.publishable_key)).catch(() => setPk(""));
  }, []);
  const stripe = useMemo(() => {
    if (!pk) return null;
    if (!stripePromise) stripePromise = loadStripe(pk);
    return stripePromise;
  }, [pk]);

  return (
    <div className="space-y-4" data-testid="checkout-payment-step">
      <div className="rounded-2xl border border-stone-200 bg-white p-3 sm:p-5 min-h-[420px]">
        {stripe && clientSecret ? (
          <EmbeddedCheckoutProvider stripe={stripe} options={{ clientSecret }}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        ) : (
          <div className="h-[400px] flex items-center justify-center text-stone-400 font-mono text-xs">{pk === "" ? tc.payUnavailable : "…"}</div>
        )}
      </div>
      <p className="text-[11px] text-stone-500 leading-relaxed flex items-start gap-2"><Lock size={12} className="mt-0.5 shrink-0" /> {tc.secure}</p>
    </div>
  );
};
